<interview-wrapper [title]="'interviews.Record Response Title' | translate">
    <div step-content>
        <ol class="ordered-list">
            <li class="list-item">
                {{'interviews.Record Response Instructions 1' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Record Response Instructions 2' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Record Response Instructions 3' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Record Response Instructions 4' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Record Response Instructions 5' | translate}}
            </li>
        </ol>
    </div>
    <div step-actions>
        <button type="button" [routerLink]="['../sample']" class="btn btn_primary">{{'interviews.Next' | translate}}</button>
    </div>
</interview-wrapper>
